<template>
	<div class="trendsContainer">
		<!-- 导航 -->
		<div class="navBar">
			<img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()">
			<ul class="navBarItem">
				<!-- <li class="busiz-active-sel"><router-link exact to="/" tag="a">首页</router-link></li> -->
				<li><router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link></li>
				<el-dropdown>
					<li><router-link to="/huaiBrand" exact style="font-size:1em;" tag="a">兰树品牌</router-link></li>
					<el-dropdown-menu class="elDropdown" slot="dropdown">
						<el-dropdown-item><router-link to="/huaiBrand" tag="a">淮树</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/brand" tag="a">心清堂</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/shuiBrand" tag="a">水姻缘</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/yiBrand" tag="a">一清堂</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/zhongBrand" tag="a">Dr.CHUNG<span
									style="vertical-align: super;">+</span></router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/lanshuBrand" tag="a">兰树</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/zbqfBrand" tag="a">植本清方</router-link></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
				<li><router-link to="/brandLanshu" exact tag="a">美业菩提</router-link></li>
				<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>

				<li><router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link></li>

				<li><router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link></li>
			</ul>
		</div>

		<img class="headerImg" src="../assets/newsBd.jpg" alt="">

		<div class="trendsMain">
			<div class="trendsMainTabs">
				<el-tabs :class="activeName == 'first' ? 'first-Background' : 'second-Background'" v-model="activeName"
					type="card" @tab-click="handleClick">



					<el-tab-pane class="elPane2"
						:class="activeName == 'second' ? 'first-Background' : 'second-Background'" label="企业新闻"
						name="second">
						<div class="secondBox">
							<div class="focusItemBox" @click="enterMedia(item.id)" v-for="(item, index) in newsData"
								:key="index">
								<div style="overflow:hidden;height: 250px;width: 440px;">
									<img style="width:100%; height:100%;margin-top: 1em; object-fit: cover;"
										class="focusImg" :src="item.thumbnail_url" alt="">
								</div>
								<div class="maskBox">
									<div class="focusTitle busiz-text-ellipes">{{ item.title }}</div>
									<div class="focusTimeBox">
										<div class="focusTime">{{ item.create_time }}</div>
									</div>
									<div class="details">
										查看详情
									</div>
								</div>
							</div>


							<div class="paginationBox">
								<!-- 分页 -->
								<zpagenav v-bind:page="pageNum" v-bind:page-size="pageSize" v-bind:total="total"
									v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
								</zpagenav>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane :class="activeName == 'third' ? 'first-Background' : 'second-Background'" label="视频资讯"
						name="third">
						<div class="thirdBox">
							<div class="focusItemBox" @click="enterVideo(item.id, item.video_url)"
								v-for="(item, index) in newsData" :key="index">
								<div style="overflow:hidden;height: 250px;width: 440px;">
									<img style="width:100%; height:100%;margin-top: 1em; object-fit: cover;"
										class="focusImg" :src="item.thumbnail_url" alt="">
								</div>
								<div class="maskBox">
									<div class="focusTitle busiz-text-ellipes">{{ item.title }}</div>
									<div class="focusTimeBox">
										<div class="focusTime">{{ item.create_time }}</div>
									</div>
									<div class="details">
										查看详情
									</div>
								</div>
							</div>

							<div class="paginationBox">
								<!-- 分页 -->
								<zpagenav v-bind:page="pageNum" v-bind:page-size="pageSize" v-bind:total="total"
									v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
								</zpagenav>
							</div>


						</div>
					</el-tab-pane>

					<el-tab-pane class="elPane2"
						:class="activeName == 'zero' ? 'first-Background' : 'second-Background'" label="菩提节 · 风采"
						name="zero">
						<div class="secondBox">
							<div class="focusItemBox" @click="enterMedia(item.id)" v-for="(item, index) in newsData"
								:key="index">
								<div style="overflow:hidden;height: 250px;width: 440px;">
									<img style="width:100%; height:100%;margin-top: 1em; object-fit: cover;"
										class="focusImg" :src="item.thumbnail_url" alt="">
								</div>
								<div class="maskBox">
									<div class="focusTitle busiz-text-ellipes">{{ item.title }}</div>
									<div class="focusTimeBox">
										<div class="focusTime">{{ item.create_time }}</div>
									</div>
									<div class="details">
										查看详情
									</div>
								</div>
							</div>


							<div class="paginationBox">
								<!-- 分页 -->
								<zpagenav v-bind:page="pageNum" v-bind:page-size="pageSize" v-bind:total="total"
									v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
								</zpagenav>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>

			</div>
			<!-- 底部 -->
			<div class="footerOuter">
				<div class="footerBox">
					<div class="footerBoxHeader">
						<div class="footerBoxHeaderLeft">
							<img class="codeImg" src="../assets/code.png" alt="">
							<span class="codeText">兰树公众号</span>
						</div>
						<div class="footerBoxHeaderRight">
							<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
							<span class="codeText">兰树云小程序</span>
						</div>
						<!-- <div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树客服(QQ)</span>
							</div> -->

					</div>
					<div class="footerMainBox">
						<li class="footerShop"><a target="_blank"
								href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
						</li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank"
								href="https://drchung.tmall.com"><span>Dr.CHUNG</span>旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a>
						</li>
						<div class="lastHeader">
							<li><router-link to="/login" tag="a">登录</router-link></li>
							|
							<li><router-link to="/login" tag="a">注册</router-link></li>
						</div>
					</div>


					<div class="footerInfoBox">
						<div class="emailBox">邮箱: postermaster@lasur.com</div>
						<div class="phoneBox">电话: 0571-89025888</div>
						<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
					</div>



					<div class="footerLine"></div>
					<div class="footerBoxBottom">
						<div class="footerLeft">
							Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank"
								href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> |
							<img height="16px" src="../assets/plice.png" />&nbsp;<a target="_blank"
								href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
								33052102000740号</a>
						</div>
					</div>

					<div style="width: 100%;height: 40px;"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { myGet, myPost, login } from "@/api/http";
export default {
	data() {
		return {
			pageNum: 1,  //显示的是哪一页
			pageSize: 9, //每一页显示的数据条数
			total: 10, //记录总数
			maxPage: 12,  //最大页数
			activeName: 'second',
			//
			seen: false,
			tableActive: 1,
			// 兰树新闻
			newsData: [],
		}
	},
	created() {
		this.gitSecurity(0)
	},
	methods: {
		handleClick(tab, event) {
			let that = this;
			console.log(tab, event);
			let selId = tab.$el.id;
			console.log(selId)
			if (selId == 'pane-zero') {
				that.tableActive = 0;
				that.pageNum = 1;
				that.gitSecurity(0)
			} else if (selId == 'pane-second') {
				that.tableActive = 1;
				that.pageNum = 1;
				that.gitSecurity(1)
			} else if (selId == 'pane-third') {
				that.tableActive = 3;
				that.pageNum = 1;
				that.gitSecurity(3)
			}
		},
		// 进入新闻详情页
		enterNews(opaction) {
			let routeUrl = this.$router.resolve({ path: '/newsDetails', query: { userId: opaction } });
			window.open(routeUrl.href, '_blank')
		},
		// 进入媒体详情页
		enterMedia(opaction) {
			let routeUrl = this.$router.resolve({ path: '/companyNewsDetail', query: { userId: opaction } });
			window.open(routeUrl.href, '_blank')
		},
		// 进入视频详情页
		enterVideo(opaction, videoUrl) {
			let routeUrl = this.$router.resolve({ path: '/videoDetail', query: { userId: opaction, videoUrl: videoUrl } })
			window.open(routeUrl.href, '_blank')
		},
		enterHome() {
			this.$router.push({ path: '/' });
		},
		//获取兰树新闻
		gitSecurity() {
			console.log('111', this.tableActive)
			// 0.兰树新闻 1.媒体聚焦 2.视频咨询
			myPost("api/messageslist/", {
				newtype: this.tableActive,
				pageNum: this.pageNum,
				pageSize: 9
			}).then((res) => {
				this.newsData = res.data.news_list;
				this.total = res.data.total_num;
			});
		},

		//pagehandler方法 跳转到page页
		pageHandler: function (page) {
			//here you can do custom state update
			this.pageNum = page;
			myPost("api/messageslist/", {
				newtype: this.tableActive,
				pageNum: page,
				pageSize: 9
			}).then((res) => {
				this.newsData = res.data.news_list;
				this.total = res.data.total_num;
			});
		},
	},

}
</script>

<style scoped>
.trendsContainer {
	display: flex;
	flex-direction: column;
}


.dynamicHeader {
	display: flex;
	width: 100%;
	padding: 0;
}

.headerImg {
	width: 100%;
	margin-top: 3rem;
}

/* 导航 */
.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #FFFFFF;
	/* border-bottom:1px solid rgba(255,255,255,0.2); */
	z-index: 999;
}


.router-link-active {
	background-color: #0F3F93 !important;
	color: #FFFFFF !important;
}


.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	/* justify-content: flex-end; */
	/* margin-left: 2em; */
	/* margin-right: 5em; */
}

.navBarItem li {
	/* list-style: none;
		padding: 1.5em 2.5em 1.5em 2.5em;
		float: left; */
	list-style: none;
	/* padding: 25px 40px 25px 40px; */
	float: left;
	/* margin-left: 2em; */
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.3em;
	padding-bottom: 1.3em;
	padding-left: 1.4em;
	padding-right: 1.4em;
}


/* .elDropdown{
		margin-left: -5em;
		margin-top: -1em;
	} */

.elDropdown a {
	color: #111111;
	text-decoration: none;
}


.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 12px;
}


.trendsMain {
	display: flex;
	flex-direction: column;
	width: 100%;
	background: #F6F6F6;
	/* position:absolute;
		top:26em; */
}

.trendsMainTabs {
	display: flex;
	flex-direction: column;
	width: 80%;
	margin: 0 auto;
	position: relative;
	background: #F6F6F6;
}


/* tabs1 */
.firstBox {
	display: flex;
	flex-direction: column;
	width: 85%;
	margin: 0 auto;
}



.el-tabs--card>.el-tabs__header {
	border-bottom: 1px solid #E4E7ED;
	width: 36%;
	margin: 0 auto;
	display: flex !important;
	justify-items: center !important;
}

.firstBoxItem {
	display: flex;
	flex-direction: row;
	width: 100%;
	margin: 0 auto;
	margin-top: 2em;
	border-bottom: 1px solid #E1E1E1;
	padding-bottom: 2em;
	cursor: pointer;
	/* padding-top: 2em; */
	transition: 0.5s ease;
}



.firstBoxItem:hover .firstBoxItemImg {
	transform: scale(1.3);
	transition: 0.8s ease;
}

.firstBoxItem:hover {
	background-color: #FFFFFF;
	transition: 0.5s ease;
}

.firstBoxItemImg {
	width: 100%;
	overflow: hidden;
	transition: 0.8s ease;
}

.imgOut {
	overflow: hidden;
	margin-left: 2em;
}

.firstBoxItemRight {
	width: 65%;
	margin-left: 3em;
	display: flex;
	flex-direction: column;
}



.firstBoxItemTitle1 {
	font-size: 1.4em;
	font-family: MicrosoftYaHei;
	color: #222222;
	font-weight: 400;
	line-height: 28px;
}



.firstBoxItemTitle2 {
	font-size: 1em;
	font-family: MicrosoftYaHei;
	color: #777777;
	line-height: 25px;
	margin-top: 1em;
}

.firstBoxItemTime {
	font-size: 0.75em;
	font-family: MicrosoftYaHei;
	color: #999999;
	line-height: 16px;
	margin-top: 2em;
}



/* footer */
.footerBox {
	width: 90%;
	/* height: 287px; */
	background: #F8F9FB;
	/* position:absolute;
	 	bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
	margin-top: 1rem;
}


.footerOuter {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F8F9FB;
}

.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}


.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderMiddle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
	/* margin-top: 0em; */
}



.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}


.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}



.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #666666;
}

.footerLeft a:hover {
	color: #003F98;
}

.footerMiddle {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerMiddle span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerRight {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerRight li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
}

.footerRight li {
	list-style: none;
}

.footerLast {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerLast span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}



.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span {
	margin-right: 10px;
}

.footerShop span::after {
	content: '+';
	display: block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	padding-left: 2em;
	line-height: 28px;
}

/* 分页 */
.pagination {
	margin: 0 auto;
	position: absolute;
	bottom: 0;
}




.pagination1 {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
	margin-top: 2em;
	position: relative;
	padding-bottom: 2em;
}


.paginationBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
}


/* tabs2 */
.secondBox {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	background: #F6F6F6;
	padding-bottom: 5em;
	/* justify-content: space-around;
	  width:100%;
	  margin: 0 auto;
	  padding-bottom: 5em;
	   */
}


.thirdBox {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	background: #F6F6F6;
	padding-bottom: 5em;
	/* justify-content: space-around;
		width:100%;
		margin: 0 auto;
		padding-bottom: 5em;
		 */
}

.focusItemBox {
	width: 30%;
	margin-left: 3.3%;
	display: flex;
	flex-direction: column;
	cursor: pointer;
	align-items: center;
	transition: 0.3s ease;
	margin-top: 2em;
	background-color: #FFFFFF;
	overflow: hidden;
	position: relative;
}


.focusTitle {
	width: 90%;
	font-size: 1em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #000001;
	line-height: 28px;
	margin: 0 auto;
	margin-top: 1em;
}


/* .focusImg{
		width: 100%;
		height: 100%;
		margin-top: 1em;
	} */


.focusTimeBox {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	justify-items: flex-start;
	margin-top: 1em;
	margin-left: 1em;
}


.focusTime {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.45);
	line-height: 22px;
}

.details {
	width: 8em;
	margin: 0 auto;
	background: #0F3F93;
	border-radius: 6px;
	text-align: center;
	padding: 0.3em;
	color: #FFFFFF;
	position: relative;
	top: 8rem;
	transition: 0.6s ease;
}

.maskBox {
	width: 100%;
	height: 10em;
	top: 1em;
	position: relative;
	transition: 0.6s ease;
	background: #FFFFFF;
	overflow: hidden;
}


.focusItemBox:hover .details {
	top: 2em;
	transition: 0.6s ease;
}



.focusItemBox:hover .maskBox {
	top: -2em;
	transition: 0.6s ease;
}


/* .el-tabs--top:nth-child(1){
			  background-color: #FFFFFF;
	 }
	 
	  .el-tabs--top:nth-child(2){
	 		background-color: #F6F6F6;
	 }
	 
	  .el-tabs--top:nth-child(3){
	 		background-color: #F6F6F6;
	 } */

.second-Background {
	background: #F6F6F6;
}

.first-Background {
	background: #FFFFFF;

}

.el-tabs__nav-wrap {
	background: red;
}

.busiz-text-ellipes {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.el-tabs__item {
	font-size: 1rem !important;
}

.busiz-text-ellipes {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}
</style>



// WEBPACK FOOTER //
// src/components/LanshuTrends.vue